import { render } from "./CadastroPF_Passo_1.vue?vue&type=template&id=73409805&scoped=true"
import script from "./CadastroPF_Passo_1.vue?vue&type=script&lang=js"
export * from "./CadastroPF_Passo_1.vue?vue&type=script&lang=js"

import "./CadastroPF_Passo_1.vue?vue&type=style&index=0&id=73409805&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73409805"]])

export default __exports__